import { Injectable, NgZone } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicGeolocationService {
  constructor(private httpClient: HttpClient, private publicHttp: PublicHttpClientService, private ngZone: NgZone) {}

  public getPostalCode(postal_code: string, closest?): Observable<any[]> {
    const options = {
      params: {
        closest: closest,
      },
    };
    return this.publicHttp
      .get("/api/public/postal_codes/" + postal_code, options)
      .pipe(tap((_) => console.log("GeolocationService.getPostalCode: Ok.")));
  }

  public getLocation(address: string, geocoder: any): Observable<any> {
    return new Observable((observer) => {
      geocoder.geocode(
        {
          address: address,
          componentRestrictions: {
            country: "MX",
          },
        },
        (results, status) => {
          this.ngZone.run(() => {
            if (status == "OK") {
              observer.next(results);
              observer.complete();
            } else {
              observer.next(null);
              observer.complete();
            }
          });
        }
      );
    });
  }

  public getLocationByLatlng(latlng: any, geocoder: any): Observable<any> {
    return new Observable((observer) => {
      geocoder.geocode(
        {
          location: latlng,
        },
        (results, status) => {
          this.ngZone.run(() => {
            observer.next(status == "OK" ? results : null);
            observer.complete();
          });
        }
      );
    });
  }

  public getCurrentLocation(): Promise<{
    coords: {
      latitude: number;
      longitude: number;
      [key: string]: any;
    };
    [key: string]: any;
  }> {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported by this browser."));
      } else {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }
    });
  }
}
